export const toastDefaultPosition = 'bottom-right'
export const toastDefaultDuration = '5000'
export const defaultFormatToHumanDateFormat = 'fr-CH'
export const defaultLocaleDateString = 'de-CH'
export const defaultCoin = 'CHF'
export const specialProductCode = '2-900'
// this was used before but now it's not used anymore, we live it here for future reference if needed again
export const chapterProductCategoryId = '-1'
export const noneActivityId = '1'
